<template>
  <v-dialog
    v-model="dialog"
    width="415"
    min-height="250"
    @keydown.esc="dialog = false"
  >
    <v-card min-height="250" class="pa-6">
      <div class="justify-center align-center d-flex ">
        <img v-if="success" src="/static/alert/alert.svg" />
        <v-icon v-if="!success" size="60" color="#FF4040">mdi-alert</v-icon>
      </div>
      <v-card-text class="pa-6 justify-center align-center d-flex ">
        <pre class="pre-text">{{ text }}</pre>
      </v-card-text>
      <v-card-actions class="justify-center align-center d-flex">
        <v-btn
          color="#3F557D"
          class="color-white"
          @click="dialog = false"
          width="150"
          height="40"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: function() {
    return {
      dialog: false,
      text: "아이디를 확인해주세요.",
      success: true,
    };
  },
  created: function() {
    this.$bus.$on("dialog", (text, success) => {
      this.dialog = true;
      this.text = text;
      this.success = success !== undefined ? success : true;
    });
  },
};
</script>

<style scoped lang="scss">
.pre-text {
  font-family: "Noto Sans KR";
}
</style>
